import Sihara from "../../assets/sihara_mockup.png";
import JobTracker from "../../assets/jobtracker.png";
import StylishLab from "../../assets/stylishlab.png";
import Trivio from "../../assets/trivio.png";
import Skillix from "../../assets/skillix.png";
import Banking from "../../assets/banking.png";

export const projectsData = [
  {
    id: 1,
    image: Sihara,
    title: "Sihara AI Ecosystem",
    category: "web",
    link: "https://www.sihara.live/",
  },
  {
    id: 2,
    image: JobTracker,
    title: "Job Application Tracker",
    category: "web",
    link: "https://github.com/chamikathereal/job-application-tracker",
  },
  {
    id: 3,
    image: StylishLab,
    title: "Stylish Lab Bridebox",
    category: "web",
    link: "https://github.com/chamikathereal/stylishlab-bridebox",
  },
  {
    id: 4,
    image: Trivio,
    title: "Trivio Messenger",
    category: "app",
    link: "https://github.com/chamikathereal/trivio-frontend",
  },
  {
    id: 5,
    image: Skillix,
    title: "Skillix Mentorship",
    category: "app",
    link: "https://github.com/chamikathereal/skillix-merchant",
  },
  {
    id: 6,
    image: Banking,
    title: "National Banking System",
    category: "web",
    link: "https://github.com/chamikathereal/national-banking-system",
  },
];

export const projectsNav = [
    {
        name: "all",
    },
    {
        name: "web",
    },
    {
        name: "app",
    },
];
